const e = [
  {
    color: "#ca562c",
    value: "<-7.0%",
    ranges: [-1 / 0, -7],
    visible: !0
  },
  {
    color: "#de8a5a",
    value: "-7.0% to -4.0%",
    ranges: [-7, -4],
    visible: !0
  },
  {
    color: "#edbb8a",
    value: "-4.0% to -1.0%",
    ranges: [-4, -1],
    visible: !0
  },
  {
    color: "#f6edbd",
    value: "-1.0% to 1.0%",
    ranges: [-1, 1],
    visible: !0
  },
  {
    color: "#b4c8a8",
    value: "1% to 4.0%",
    ranges: [1, 4],
    visible: !0
  },
  {
    color: "#70a494",
    value: "4.0% to 7.0%",
    ranges: [4, 7],
    visible: !0
  },
  {
    color: "#008080",
    value: ">7.0%",
    ranges: [7, 1 / 0],
    visible: !0
  }
], r = [
  {
    color: "#ca562c",
    value: "<-10.0%",
    ranges: [-1 / 0, -10],
    visible: !0
  },
  {
    color: "#de8a5a",
    value: "-10.0% to -5.0%",
    ranges: [-10, -5],
    visible: !0
  },
  {
    color: "#edbb8a",
    value: "-5.0% to -2.0%",
    ranges: [-5, -2],
    visible: !0
  },
  {
    color: "#f6edbd",
    value: "-2.0% to 2.0%",
    ranges: [-2, 2],
    visible: !0
  },
  {
    color: "#b4c8a8",
    value: "2.0% to 5.0%",
    ranges: [2, 5],
    visible: !0
  },
  {
    color: "#70a494",
    value: "5.0% to 10.0%",
    ranges: [5, 10],
    visible: !0
  },
  {
    color: "#008080",
    value: ">10.0%",
    ranges: [10, 1 / 0],
    visible: !0
  }
];
export {
  e as POP_GROWTH_2021_2023_STATIC_BINS,
  r as POP_GROWTH_2023_2028_STATIC_BINS
};
//# sourceMappingURL=index.es476.js.map
